import React from 'react'
import { Box, Container, Grid, Typography } from '@mui/material/'
import NewsTabs from '@containers/Home/NewsTabs'
import { IssueCategoryFragment } from '@services/graphcms/client'
import { IssueTable } from './IssueTable'

type Props = {
  issueCategories: IssueCategoryFragment[]
}

export const Issues = (props: Props) => (
  <>
    <NewsTabs />
    <Container maxWidth="md">
      <Box mt={2} mb={8} minHeight="78vh">
        <Typography align="center" fontWeight="bold" variant="h5">
          トラブル集
        </Typography>
        <Box mt={3}>
          {Array.isArray(props.issueCategories) &&
            props.issueCategories.map((issueCategory) => (
              <>
                <Box mt={6} mb={2}>
                  <Typography fontWeight="bold" variant="h6">
                    {issueCategory.name}
                  </Typography>
                </Box>
                <Grid container={true} spacing={4}>
                  <IssueTable issues={issueCategory.issues} />
                </Grid>
              </>
            ))}
        </Box>
      </Box>
    </Container>
  </>
)
